/**
 * AppNavbar - Navigation for the app platform (app.domain.com)
 * Used when user is in the authenticated app context (dashboards, admin, etc.)
 */
import { RoleBasedNavbar } from './RoleBasedNavbar';

export const AppNavbar = () => {
  return <RoleBasedNavbar />;
};
